import { type GetHookResponse } from '../hooks'
import { accountStatusesKey } from '../keys'
import { useTantalimQuery } from '../query'
import {
  type AccountStatusData,
  type AccountStatusId,
  type AccountStatusListInput,
  type AccountStatusListSuccess,
  HOUR,
  isEmpty,
  MINUTE,
  sortAccountStatuses,
} from '@terros/common'
import { useMemo } from 'react'

type Success = AccountStatusListSuccess

export function useAccountStatuses(input?: AccountStatusListInput): GetHookResponse<Success> {
  return useTantalimQuery<AccountStatusListInput, Success, Success>({
    url: '/account/status/list',
    queryKey: accountStatusesKey(input),
    input: input ?? {},
    convertResponse: (d) => ({ ...d, statuses: sortAccountStatuses(d.statuses) }),
    options: {
      staleTime: 15 * MINUTE,
      gcTime: HOUR,
    },
  })
}

export function useAccountStatusesMap(input?: AccountStatusListInput): Map<AccountStatusId, AccountStatusData> {
  const { data: accountStatuses } = useAccountStatuses(input)
  return useMemo(() => toAccountStatusMap(accountStatuses?.statuses) ?? new Map(), [accountStatuses])
}
const toAccountStatusMap = (
  accountStatuses: AccountStatusData[] | undefined
): Map<AccountStatusId, AccountStatusData> | undefined => {
  if (isEmpty(accountStatuses)) return
  return new Map<AccountStatusId, AccountStatusData>(accountStatuses.map((status) => [status.statusId, status]))
}
